import { render } from "./sentenciadoList.vue?vue&type=template&id=6e834b59"
import script from "./sentenciadoList.vue?vue&type=script&lang=js"
export * from "./sentenciadoList.vue?vue&type=script&lang=js"

import "./sentenciadoList.vue?vue&type=style&index=0&id=6e834b59&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__